module.exports = __webpack_public_path__ + "img/UNPLUGGED.8bd267a8.png";